import { create } from 'zustand';

/** The signed-in person, as mcper.io shows them. */
/** id is the account id, the only thing analytics ever learns about the person. */
export type Person = { id?: string; email: string; name: string };

type SessionState = {
  accessToken: string | null;
  person: Person | null;
  setSession(token: string, person: Person): void;
  clear(): void;
};

const TOKEN_KEY = 'mcperio.access';

/** The access token lives in memory and sessionStorage (never localStorage); the session itself is an httpOnly cookie. */
function initialToken(): string | null {
  try {
    return sessionStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export const useSession = create<SessionState>((set) => ({
  accessToken: initialToken(),
  person: null,
  setSession(token, person) {
    try {
      sessionStorage.setItem(TOKEN_KEY, token);
    } catch {
      /* private mode: in memory only */
    }
    set({ accessToken: token, person });
    // Analytics knows the person by account id only (never email or name).
    if (person.id) (window as { posthog?: { identify?: (id: string) => void } }).posthog?.identify?.(person.id);
  },
  clear() {
    try {
      sessionStorage.removeItem(TOKEN_KEY);
    } catch {
      /* ignore */
    }
    set({ accessToken: null, person: null });
    (window as { posthog?: { reset?: () => void } }).posthog?.reset?.();
  },
}));
